<template>
  <main class="form-parent">
    <form class="form-signin" @submit.prevent="login">
      <img class="mb-4" src="@/assets/RIM_Logo_Pos_RGB-300x176.png" alt="" />
      <h1 class="h3 mb-3 fw-normal">Please sign in</h1>

      <div class="form-floating">
        <input
          v-model="email"
          type="email"
          class="form-control"
          id="email"
          placeholder="name@example.com"
        />
        <label for="email">Email address</label>
      </div>
      <div class="form-floating">
        <input
          v-model="password"
          type="password"
          class="form-control"
          id="password"
          placeholder="Password"
        />
        <label for="password">Password</label>
      </div>
      <p class="text-danger">{{ error }}</p>
      <button class="w-100 btn btn-lg btn-primary" type="submit">
        Sign in
      </button>
      <p class="mt-5 mb-3 text-muted">&copy; 2020–2021</p>
    </form>
  </main>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "Login",

  setup() {
    const store = useStore();
    const router = useRouter();

    const email = ref("");
    const password = ref("");

    const error = ref("");

    const login = () => {
      store
        .dispatch("login", {
          email: email.value,
          password: password.value,
        })
        .then(() => {
          router.push({ name: "dashboard" });
        })
        .catch((err) => {
          password.value = "";
          error.value = err;
        });
    };

    return {
      email,
      password,
      error,
      login,
    };
  },
};
</script>

<style scoped>
.form-parent {
  display: block;
  text-align: center;
}

.form-signin {
  display: inline-block;
  margin: auto;
  text-align: center;
  padding: 15px;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-floating:focus-within {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
